/**
 * Game Size Type
 */
type GameSize = {
    width: number;
    height: number;
    centerX: number;
    centerY: number;
    canvasWidth: string;
    canvasHeight: string;
}


class BaseScene extends Phaser.Scene
{
    /**
     * Returns the game size
     */
    protected getGameSize(): GameSize
    {
        const gameCanvas = this.sys.game.canvas;

        const gameWidth = gameCanvas.width as number;
        const gameHeight = gameCanvas.height as number;

        const gameCenterX = gameWidth / 2;
        const gameCenterY = gameHeight / 2;

        return {
            width: gameWidth,
            height: gameHeight,
            centerX: gameCenterX,
            centerY: gameCenterY,
            canvasWidth: gameCanvas.style.width,
            canvasHeight: gameCanvas.style.height
        }
    }

    /**
     * Enables shutdown callback
     */
    protected enableShutdown()
    {
        this.events.once('shutdown', this.shutdown.bind(this));
    }

    /**
     * Shutdown callback
     */
    public shutdown()
    {

    }
}

export default BaseScene;